import { Score } from "score_data";
import { Services } from "../services/Services";
import { AppSettings } from "../settings/AppSettings";

export class SongDO {
	/**unique id in the song library*/
	public libId:string;
	/**id of the song library category this song appears in*/
	public categoryId:string;
	/**title of the song*/
	public title:string;
	/**the [SongType], such as RhythmAssessment or RecorderAssessment*/
	public type:SongType;
	
	public path:string;
	
	public musicXMLString:string;
	public score:Score;
	/**if null, song's default tempo should be used*/
	public overrideTempo:number;
	
	constructor(){
		
	}
	
	public static fromLibrarySongJson(categoryId:string, data:any):SongDO {
		let sdo = new SongDO();
		
		sdo.categoryId = categoryId;
		sdo.libId = data['libId'];
		sdo.title = data['title'];
		sdo.type = data['type'];
		sdo.path = AppSettings.resourcesPath + data['path'];
		sdo.overrideTempo = data['tempo']; //optional
		
		return sdo;
	}
	
}

export enum SongType {
	RhythmAssessment,
	RecorderAssessment
}